import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function alphaNumericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-Z0-9]+$/.test(control.value);
    return !valid
      ? {
          invalidAlphaNumeric: {
            value: control.value,
            msg: 'Nevalidný reťazec, neobsahuje kombináciu písmen a číslic.',
          },
        }
      : null;
  };
}
